import React from 'react';

const SettingsSaveBar = React.memo(({ onSave, isSaving }) => (
  <div className="product-settings-panel-footer">
    <p className="product-settings-panel-footer-hint">
      <i className="fas fa-info-circle" aria-hidden="true" />
      Yukarıdaki alanlarda yaptığınız değişiklikleri kaydetmeyi unutmayın.
    </p>
    <button
      type="button"
      className="btn-save product-settings-panel-save-btn"
      onClick={onSave}
      disabled={isSaving}
    >
      {isSaving ? (
        <>
          <i className="fas fa-spinner fa-spin" aria-hidden="true" />
          Kaydediliyor...
        </>
      ) : (
        <>
          <i className="fas fa-save" aria-hidden="true" />
          Ayarları Kaydet
        </>
      )}
    </button>
  </div>
));

export default SettingsSaveBar;
